<template>
  <div>
    <div class="uk-card uk-card-default">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              Переводы
            </h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-grid uk-grid-small" data-uk-grid>
              <!--add btn-->
              <div>
                <button class="uk-button tm-button-success" type="button" @click="openAddingLanguageDialog">
                  {{ local_page_keys.title_page_add_language }}
                </button>
              </div>
              <!--search-->
              <div>
                <div class="uk-grid uk-grid-collapse uk-flex-middle" data-uk-grid>
                  <div class="uk-search uk-search-default" style="width: 300px;">
                    <span data-uk-search-icon class="uk-icon uk-search-icon"></span>
                    <input v-model="search" @input="getAllPage" class="uk-search-input" type="search"
                           placeholder="Поиск">
                  </div>
                  <div>
                    <button data-uk-tooltip="Очистить поиск" @click="clearSearch"
                            class="uk-button uk-button-success tm-button-schedule-table" style="border: none;">
                      <i class="md-icon md-icon-font md-theme-default">clear</i>
                    </button>
                  </div>
                </div>
              </div>
              <!--выбор языка (по деф первый язык юзера в настройках профиля) -->
              <div>
                <select class="uk-select" v-model="language" @change="getAllPage">
                  <option v-for="language in languagesList"
                          :key="language.id"
                          :value="language.id"
                  >{{ language.name }}
                  </option>
                </select>
              </div>
              <!--категории-->
              <div>
                <select class="uk-select" v-model="selectCategory" name="category" id="category" @change="getAllPage">
                  <option value="" selected="selected">Все категории</option>
                  <option v-for="category in categories"
                          :key="category.index"
                          :value="category.id"
                  >{{ category.name_page }} ({{ category.id }})
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <!--Пагинация сверху-->
        <ul class="uk-pagination tm-pagination uk-flex-center uk-margin uk-text-small" v-if="pagination.totalPages">
          <li :class="(pagination.currentPage <= 1 ? 'uk-disable' : '')">
            <a href="#" class="uk-link-reset" @click="goToPrevious">
              <span data-uk-pagination-previous></span>
            </a>
          </li>
          <template v-for="page in pagination.totalPages">
            <li :key="page" class="uk-active" v-if="pagination.currentPage == page">
          <span>
            {{ pagination.currentPage }}
          </span>
            </li>
            <li :key="page" @click="goToPage(page)" v-else>
              <a href="#" class="uk-link-reset">{{ page }}</a>
            </li>
          </template>
          <li :class="(pagination.currentPage >= pagination.totalPages ? 'uk-disable' : '')">
            <a href="#" class="uk-link-reset" @click="goToNext">
              <span data-uk-pagination-next></span>
            </a>
          </li>
        </ul>
        <!--шапка-->
        <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;">
          <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid uk-text-center" data-uk-grid>
            <div class="uk-width-auto">
              <div style="width: 90px;" class="uk-padding-small">
                id
                <a href="#" class="uk-display-inline-block uk-link-reset"
                   data-uk-tooltip="title: Сортировка по имени фразы">
                  <span class="uk-icon" @click="sort('localization_id')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                    </svg>
                  </span>
                  <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="sort('localization_id')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
            <div class="uk-width-medium">
              <div class="uk-padding-small">
                Фраза
                <a href="#" class="uk-display-inline-block uk-link-reset"
                   data-uk-tooltip="title: Сортировка по имени фразы">
                  <span class="uk-icon" @click="sort('keys_pages.name_key')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                    </svg>
                  </span>
                  <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="sort('keys_pages.name_key')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
            <div class="uk-width-medium">
              <div class="uk-padding-small">
                Страница
                <a href="#" class="uk-display-inline-block uk-link-reset"
                   data-uk-tooltip="title: Сортировка по странице применения">
                  <span class="uk-icon" @click="sort('bind_pages.name_page')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                    </svg>
                  </span>
                  <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="sort('bind_pages.name_page')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
            <div class="uk-width-expand">
              <div class="uk-padding-small">
                Перевод
              </div>
            </div>
            <div class="uk-width-auto">
              <div style="width: 60px;" class="uk-padding-small">
              </div>
            </div>
          </div>
        </div>
        <preloader :is-visible="isLoading"></preloader>
        <!--список-->
        <div class="uk-padding-small uk-text-center" v-if="pageList.length === 0">
          Поиск не дал результатов
        </div>
        <div v-else class="uk-grid uk-grid-collapse uk-grid-divider uk-child-width-1-1" data-uk-grid>
          <template v-for="(item, index) in pageList">
            <div class="uk-grid-collapse uk-flex-middle tm-grid-bg-hover uk-grid" data-uk-grid :key="index">
              <!--id фразы-->
              <div class="uk-text-center" style="width: 90px;">
                <div class="uk-padding-small uk-flex uk-text-center uk-flex-center">
                  <span class="uk-label tm-label">{{ item.localization_id }}</span>
                </div>
              </div>
              <!--фраза-->
              <div class="uk-width-medium">
                <div class="uk-padding-small uk-text-truncate" :data-uk-tooltip="item.name_key">
                  {{ item.name_key }}
                </div>
              </div>
              <!--категория-->
              <div class="uk-width-medium uk-text-center">
                <div class="uk-padding-small">
                  <span class="uk-label tm-label">{{ item.id_page }}</span> {{ item.name_page }}
                </div>
              </div>
              <!--перевод-->
              <div class="uk-width-expand">
                <div class="uk-padding-small">
                  {{ item.text }}
                </div>
              </div>
              <!--кнопка-->
              <div class="uk-text-center" style="width: 60px;">
                <div class="uk-padding-small uk-flex uk-text-center uk-flex-center">
                  <button type="button"
                          @click="openEdit(item.id_key_page)"
                          style="padding: 0 5px;"
                          class="uk-icon uk-link-text" data-uk-tooltip="title: Редактировать фразу">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="none" stroke="#000"
                            d="M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z"></path>
                      <polyline fill="none" stroke="#000"
                                points="16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5"></polyline>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="uk-modal-footer">
        <!--Пагинация внизу-->
        <ul class="uk-pagination tm-pagination uk-flex-center uk-margin uk-text-small" v-if="pagination.totalPages">
          <li :class="(pagination.currentPage <= 1 ? 'uk-disable' : '')">
            <a href="#" class="uk-link-reset" @click="goToPrevious">
              <span data-uk-pagination-previous></span>
            </a>
          </li>
          <template v-for="page in pagination.totalPages">
            <li :key="page" class="uk-active" v-if="pagination.currentPage == page">
          <span>
            {{ pagination.currentPage }}
          </span>
            </li>
            <li :key="page" @click="goToPage(page)" v-else>
              <a href="#" class="uk-link-reset">{{ page }}</a>
            </li>
          </template>
          <li :class="(pagination.currentPage >= pagination.totalPages ? 'uk-disable' : '')">
            <a href="#" class="uk-link-reset" @click="goToNext">
              <span data-uk-pagination-next></span>
            </a>
          </li>
        </ul>
      </div>
    </div>

<!--    <div>-->
      <!--            <h3>{{ local_page_keys.title_page_add_language }}</h3>-->
      <!--            <label>{{ local_page_keys.label_full_name }}</label>-->
      <!--            <input v-model="language" class="uk-form-small uk-input" style="width: 35%;margin: 1%"/>-->
      <!--            <label>{{ local_page_keys.label_short_name }}</label>-->
      <!--            <input v-model="short_language" class="uk-form-small uk-input" style="width: 35%;margin: 1%"/>-->
      <!--            <button type="button" class="uk-button uk-button-small uk-button-success md-success" @click="creteLanguages()">-->
      <!--              <span class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polyline-->
      <!--                  fill="none" stroke="#000" stroke-width="1.1" points="4,10 8,15 17,4"></polyline></svg></span>-->
      <!--            </button>-->
      <!--    </div>-->

      <!--    <div class="uk-grid uk-flex-middle uk-margin" data-uk-grid>-->
      <!--            <div class="uk-width-auto">-->
      <!--              <h3 class="uk-margin-remove">{{ local_page_keys.label_choose_page }}</h3>-->
      <!--            </div>-->
      <!--            <div class="uk-width-expand">-->
      <!--              <md-field style="margin-top: 0;">-->
      <!--                <label>{{ local_page_keys.label_choose }}:</label>-->
      <!--                <md-select class="form-control field_level" v-model="selectedPage" name="selectedPage" ref="roleSelect"-->
      <!--                           @input="getTranslate()">-->
      <!--                  <md-option v-for="option in pageList"-->
      <!--                             :key="option.index"-->
      <!--                             :value="option.name"-->
      <!--                  >{{ option.name }} ({{ option.url }})-->
      <!--                  </md-option>-->
      <!--                </md-select>-->
      <!--              </md-field>-->
      <!--            </div>-->
      <!--    </div>-->

      <!--    <v-app v-if="items.length !== 0 && !loading" id="inspire">-->
      <!--      <v-card>-->
      <!--        <v-tabs-->
      <!--            v-model="tab"-->
      <!--            background-color="primary"-->
      <!--            dark-->
      <!--        >-->
      <!--          <v-tab-->
      <!--              v-for="item in items"-->
      <!--              :key="item.tab"-->
      <!--          >-->
      <!--            {{ item.tab }}-->
      <!--          </v-tab>-->
      <!--        </v-tabs>-->
      <!--        <v-tabs-items v-model="tab">-->
      <!--          <v-tab-item-->
      <!--              v-for="item in items"-->
      <!--              :key="item.tab">-->
      <!--            <v-card flat>-->
      <!--              <v-card-text>-->
      <!--                <md-card>-->
      <!--                  <md-card-content>-->
      <!--                    <md-table v-model="item.content" table-header-color="green">-->
      <!--                      <md-table-row slot="md-table-row" slot-scope="{ index }">-->
      <!--                        <md-table-cell :md-label="local_page_keys.table_label_key">{{-->
      <!--                            item.content[index].keys_pages-->
      <!--                          }}-->
      <!--                        </md-table-cell>-->
      <!--                        <md-table-cell :md-label="local_page_keys.table_label_text"-->
      <!--                                       v-if="changedId !== item.content[index].id"-->
      <!--                                       @click.native="changedId = item.content[index].id">-->
      <!--                          <div>-->
      <!--                            {{ item.content[index].text }}-->
      <!--                          </div>-->
      <!--                        </md-table-cell>-->
      <!--                        <md-table-cell :md-label="local_page_keys.table_label_text"-->
      <!--                                       v-if="changedId === item.content[index].id">-->
      <!--                          &lt;!&ndash;                            <input style="width:100%" name="text"  :id="'TextValue_'+item.content[index].id" :value="item.content[index].text" > &ndash;&gt;-->
      <!--                          <textarea class="tm-textarea-active" autofocus-->
      <!--                                    style="width:100%"-->
      <!--                                    :id="'TextValue_'+item.content[index].id" :value="item.content[index].text"/>-->
      <!--                        </md-table-cell>-->
      <!--                        <md-table-cell :md-label="local_page_keys.table_label_save">-->
      <!--                          <md-button v-if="changedId === item.content[index].id"-->
      <!--                                     @click="updateText(item.content[index].id,item.content[index].id_keys_pages, item.tab)">-->
      <!--                            {{ local_page_keys.button_save }}-->
      <!--                          </md-button>-->
      <!--                        </md-table-cell>-->
      <!--                      </md-table-row>-->
      <!--                    </md-table>-->
      <!--                  </md-card-content>-->
      <!--                </md-card>-->
      <!--              </v-card-text>-->
      <!--            </v-card>-->
      <!--          </v-tab-item>-->
      <!--        </v-tabs-items>-->
      <!--      </v-card>-->
      <!--    </v-app>-->
      <!--    <div v-else-if="loading">-->
      <!--      <v-progress-circular-->
      <!--          :width="2"-->
      <!--          indeterminate-->
      <!--          style="color: forestgreen"></v-progress-circular>-->
<!--    </div>-->

    <!--Добавление языка-->
    <md-dialog
        :md-active.sync="showDialogAddingLanguage"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-translation-edit">
      <div class="uk-modal-header">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialogAddingLanguage = false">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-modal-title">
          <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small">
            <div class="uk-text-bold">
              {{ local_page_keys.title_page_add_language }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small uk-child-width-1-1">
          <div>
            <div class="uk-margin-xsmall uk-text-small">
              {{ local_page_keys.label_full_name }}
            </div>
            <input v-model="name_language" id="name_language" class="uk-input"
                   :class="{'tm-val-error' : this.languageErrors.name }"/>
          </div>
          <div>
            <div class="uk-margin-xsmall uk-text-small">
              {{ local_page_keys.label_short_name }}
            </div>
            <input v-model="short_language" id="short_language" class="uk-input"
                   :class="{'tm-val-error' : this.languageErrors.short }"/>
          </div>
          <div class="uk-margin-medium-top">
            <button type="button" class="uk-button uk-button-default uk-modal-close"
                    @click="showDialogAddingLanguage = false">Отмена
            </button>
            <button type="button" class="uk-button tm-button-success uk-margin-xsmall-left" @click="createLanguages()">
              <span class="uk-icon uk-margin-xsmall-right"><svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polyline fill="none" stroke="#000" stroke-width="1.1" points="4,10 8,15 17,4"></polyline></svg></span>Создать
            </button>
          </div>
        </div>
      </div>
    </md-dialog>

    <!--Редактирование фразы-->
    <md-dialog
        v-if="Object.keys(this.currentTranslate).length"
        :md-active.sync="showDialogEditTranslate"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-translation-edit">
      <div class="uk-modal-header">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialogEditTranslate = false">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-modal-title">
          <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small">
            <div>
              <span class="uk-label tm-label">{{ currentTranslate.id }}</span>
            </div>
            <div class="uk-text-bold uk-text-truncate" style="font-size: 20px;">
              {{ currentTranslate.name_key }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-grid uk-flex-middle uk-grid-small uk-margin" data-uk-grid>
          <div>
            Категория
          </div>
          <div>
            <div class="uk-label tm-label">
              {{ currentTranslate.page_name }} ({{ currentTranslate.page_id }})
            </div>
          </div>
        </div>
        <!--        Табы языков (по деф первый язык юзера в настройках профиля)-->
        <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small uk-child-width-1-1">
          <div>
            <div class="uk-width-1-1">
              <v-tabs class="tm-tabs" v-model="tab">
                <v-tab v-for="languages of languagesList" :key="languages.id">
                  {{ languages.name }}
                </v-tab>
              </v-tabs>
              <v-tabs-items class="tm-tabs-content" v-model="tab">
                <v-tab-item
                    v-for="languages of languagesList"
                    :key="languages.id">
                  <v-card flat>
                    <v-card-text>
                      <textarea class="uk-textarea" rows="5" v-model="tabDataTranslates[languages.id].text"></textarea>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
          <div class="uk-margin-medium-top">
            <button type="button" class="uk-button uk-button-default uk-modal-close" @click="closeModal()">Отмена
            </button>
            <button type="button" class="uk-button tm-button-success uk-margin-small-left"
                    @click="updateTranslates(false)">Сохранить
            </button>
            <button type="button" class="uk-button tm-button-success uk-margin-small-left"
                    @click="updateTranslates(true)">Сохранить и закрыть
            </button>
          </div>
        </div>
      </div>
    </md-dialog>

  </div>
</template>

<script>
import Preloader from "../Components/Preloader";
import axios from "axios";

export default {
  name: "TranslatePageAdmin",
  data() {
    return {
      loading: false,
      pageList: {},
      tab: null,
      language: '',
      name_language: '',
      short_language: '',
      languageErrors: {
        name: false,
        short: false
      },
      local_page_keys: {},
      showDialogAddingLanguage: false,
      showDialogEditTranslate: false,
      currentTranslate: {},
      search: '',
      sortField: 'keys_pages.name_key',
      sortDirection: 'asc',
      pagination: {
        perPage: 30,
        currentPage: 1,
        totalPages: null,
      },
      isLoading: false,
      categories: [],
      selectCategory: '',
      languagesList: [],
      tabDataTranslates: [],
    };
  },
  components: {Preloader},
  methods: {
    async getAllPage() {
      //this.isLoading = true;
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        search: this.search,
        filterCategory: this.selectCategory,
        language: this.language,
        sort: this.sortField,
        direction: this.sortDirection,
      }

      await this.$store.dispatch('localization/getListTranslate', params);
      let response = await this.$store.getters['localization/getListTranslate'];

      this.pageList = response.translates.data;
      this.categories = response.categories;
      this.languagesList = response.languages;
      if (!this.language) {
        this.language = response.user_language_id;
      }
      this.pagination.currentPage = response.translates.current_page;
      this.pagination.totalPages = Math.ceil(response.translates.total / this.pagination.perPage);
      //this.isLoading = false;
    },
    async sort(field) {
      if (field === this.sortField) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }
      await this.getAllPage();
    },
    async createLanguages() {
      this.languageErrors.short = false;
      this.languageErrors.name = false;

      if (this.name_language === '' || this.name_language.length <= 2 || this.short_language === '') {
        if (this.name_language === '') {
          this.languageErrors.name = true;
        }
        if (this.short_language === '') {
          this.languageErrors.short = true;
        }
        UIkit.notification({
          message: this.local_page_keys.alert_fill_in_the_field_or_enter_the_full_name + '!',
          pos: 'top-center',
          status: 'error',
          timeout: 1500
        })
      } else {
        await this.$store.dispatch('localization/createLanguage', {
          name: this.name_language,
          short_name: this.short_language
        });
        let lang = await this.$store.getters['localization/createLanguage'];
        this.name_language = ''
        this.short_language = ''
        this.showDialogAddingLanguage = false;
        await this.getAllPage();
        UIkit.notification({
          message: lang + ' ' + this.local_page_keys.alert_language_added,
          pos: 'top-center',
          status: 'success',
          timeout: 1500
        })
      }
    },
    openAddingLanguageDialog() {
      this.showDialogAddingLanguage = true;
    },
    async openEdit(id) {
      await this.$store.dispatch('localization/getTranslate', id);
      let response = await this.$store.getters['localization/getTranslate'];
      this.currentTranslate = response.translate;
      let page = this.categories.find(category => category.id === this.currentTranslate.id_page);

      this.currentTranslate.page_name = page.name_page;
      this.currentTranslate.page_id = page.id;
      this.initTab();
      this.showDialogEditTranslate = true;
    },
    initTab() {
      this.tabDataTranslates = this.languagesList.reduce((acc, language) => {
        acc[language.id] = {
          id: '',
          text: '',
        };
        return acc;
      }, {});

      if (Object.keys(this.currentTranslate).length) {
        this.currentTranslate.localizations.forEach((item) => {
          this.tabDataTranslates[item.id_languages].id = item.id;
          this.tabDataTranslates[item.id_languages].text = item.text;
        });
      }
    },
    async goToNext() {
      if (this.pagination.currentPage + 1 > this.pagination.totalPages) {
        return;
      }
      this.pagination.currentPage++;
      await this.getAllPage();
    },
    async goToPrevious() {
      if (this.pagination.currentPage - 1 <= 0) {
        return;
      }
      this.pagination.currentPage--;
      await this.getAllPage();
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.getAllPage();
    },
    async updateTranslates(closeDialog) {
      let data = new FormData();
      this.loading = true;
      const url = process.env.VUE_APP_API_BASE_URL;
      data.append('translates', JSON.stringify(this.tabDataTranslates));
      data.append('page', this.currentTranslate.page_id);

      await axios.post(`${url}/update_translate/` + this.currentTranslate.id, data ).then(async response => {
        UIkit.notification({message: 'Translations saved', pos: 'top-center', status: 'success', timeout: 1500})
        this.getAllPage();

        if (closeDialog) {
          this.closeModal();
        }
      }).catch(err => {
        if (err.response.data && err.response.data.errors) {
          this.functionErrors = err.response.data.errors;
        }
        UIkit.notification({
          message: "Function isn't saved." + err.response.data.message ?? '',
          pos: 'top-center',
          status: 'error',
          timeout: 1500
        })
      });
      this.loading = false;
    },
    closeModal() {
      this.currentTranslate = {};
      this.showDialogEditTranslate = false;
    },
    async clearSearch() {
      this.search = '';
      await this.getAllPage();
    }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('translate');
    await this.getAllPage();
  }
}
</script>

<style>
.tm-dialog-translation-edit > div {
  width: 1000px;
}

.tm-textarea-active {
  border: 1px solid #4caf50;
  padding: 5px;
  min-height: 100px;
}
</style>